<template>
	<div v-if="isOpen">
		<div
			:class="classNames.modalVideo"
			tabIndex='-1'
			role='dialog'
			:aria-label="aria.openMessage"
			@click="$emit('update:isOpen', false)"
			@keydown.esc="$emit('update:isOpen', false)"
		>
			<div :class="classNames.modalVideoBody">
				<button
					:class="classNames.modalVideoCloseBtn"
					:aria-label="aria.dismissBtnMessage"
					ref="closeBtn"
					@click="$emit('update:isOpen', false)"
				/>
				<div :class="classNames.modalVideoInner">
					<div
						:class="classNames.modalVideoIframeWrap"
						:style="{'padding-bottom': paddingBottom}"
					>
						<iframe
							width='460'
							height='230'
							:src="fullVideoUrl"
							frameBorder='0'
							:allowFullScreen="allowFullScreen"
							tabIndex='-1'
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name:  'ModalVideo',
	props: {
		videoId: String,
		channel: String,
		isOpen:  Boolean,
		youtube: {
			type:    Object,
			default: function() {
				return {
					autoplay:       1,
					cc_load_policy: 1,
					color:          null,
					controls:       1,
					disablekb:      0,
					enablejsapi:    0,
					end:            null,
					fs:             1,
					h1:             null,
					iv_load_policy: 1,
					list:           null,
					listType:       null,
					loop:           0,
					modestbranding: null,
					origin:         null,
					playlist:       null,
					playsinline:    null,
					rel:            0,
					showinfo:       1,
					start:          0,
					wmode:          'transparent',
					theme:          'dark'
				};
			}
		},
		ratio: {
			type:    String,
			default: '16:9'
		},
		vimeo: {
			type:    Object,
			default: function() {
				return {
					api:       false,
					autopause: true,
					autoplay:  true,
					byline:    true,
					callback:  null,
					color:     null,
					height:    null,
					loop:      false,
					maxheight: null,
					maxwidth:  null,
					player_id: null,
					portrait:  true,
					title:     true,
					width:     null,
					xhtml:     false
				};
			}
		},
		allowFullScreen: {
			type:    Boolean,
			default: true
		},
		animationSpeed: {
			type:    Number,
			default: 300
		},
		classNames: {
			type:    Object,
			default: function() {
				return {
					modalVideoEffect:     'modal-video-effect',
					modalVideo:           'modal-video',
					modalVideoClose:      'modal-video-close',
					modalVideoBody:       'modal-video-body',
					modalVideoInner:      'modal-video-inner',
					modalVideoIframeWrap: 'modal-video-movie-wrap',
					modalVideoCloseBtn:   'modal-video-close-btn'
				};
			}
		},
		aria: {
			type:    Object,
			default: function() {
				return {
					openMessage:       'Modal video opened',
					dismissBtnMessage: 'Close the modal video'
				};
			}
		}
	},
	methods: {
		getQueryString(obj) {
			let url = '';
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					if (obj[key] !== null) {
						url += key + '=' + obj[key] + '&';
					}
				}
			}
			return url.substring(0, url.length - 1);
		},
		getYoutubeUrl(youtube, videoId) {
			const query = this.getQueryString(youtube);
			return '//www.youtube.com/embed/' + videoId + '?' + query;
		},
		getVimeoUrl(vimeo, videoId) {
			const query = this.getQueryString(vimeo);
			return '//player.vimeo.com/video/' + videoId + '?' + query;
		},
		getPadding(ratio) {
			const arr = ratio.split(':');
			const width = Number(arr[0]);
			const height = Number(arr[1]);
			const padding = height * 100 / width;
			return padding + '%';
		}
	},
	computed: {
		fullVideoUrl() {
			if (this.channel === 'youtube') {
				return this.getYoutubeUrl(this.youtube, this.videoId);
			}
			else if (this.channel === 'vimeo') {
				return this.getVimeoUrl(this.vimeo, this.videoId);
			}
			return '';
		},
		paddingBottom() {
			return this.getPadding(this.ratio);
		}
	},
	watch: {
		isOpen: {
			handler: function(val) {
				this.$nextTick(() => {
					if (typeof this.$refs.closeBtn !== 'undefined') {
						this.$refs.closeBtn.focus();
					}
				});
			},
			deep: true
		}
	}
};
</script>
